import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import * as API from "services/api"
import { isEqual } from "lodash-es"
import {
  facilityId,
  facilityName,
  facilityGroupCodeIds as getAssignedFacilityGroupCodeIds,
  setAssignedFacilityGroupCodeIds,
} from "reduxSlices/adminFacilitySlice"
import { useCustomName } from "hooks"
import { FACILITY_KEY } from "utils/customNameHelpers"
import { MultiSelect } from "components/shared/multiSelects"
import { errorToast } from "components/shared/toast"

const updateFailureMessage = (facilityCustomNameInSentence) => (
  `Something went wrong. Unable to update ${facilityCustomNameInSentence} group codes.`
)

const facilityGroupCodesOptionsList = (facilityGroupCodes) => facilityGroupCodes.map((facilityGroupCode) => ({
  label: facilityGroupCode.name,
  value: facilityGroupCode.id,
}))

const FacilityGroupCodesSelect = ({ facilityGroupCodes }) => {
  const id = useSelector(facilityId)
  const name = useSelector(facilityName)
  const assignedFacilityGroupCodeIds = useSelector(getAssignedFacilityGroupCodeIds)

  const {
    nameInSentence: facilityCustomNameInSentence,
  } = useCustomName(FACILITY_KEY)

  const dispatch = useDispatch()

  const updateFacilityGroupCodes = async (values) => {
    if (!isEqual(assignedFacilityGroupCodeIds, values)) {
      const response = await API.updateFacilityGroupCodeAssignments({ facilityId: id, facilityGroupCodeIds: values })

      if (response.ok) {
        dispatch(setAssignedFacilityGroupCodeIds(response.data))
      } else {
        errorToast(updateFailureMessage(facilityCustomNameInSentence))
      }
    }
  }

  return (
    <MultiSelect
      onChange={updateFacilityGroupCodes}
      options={facilityGroupCodesOptionsList(facilityGroupCodes)}
      placeholder={`Select ${facilityCustomNameInSentence} group codes`}
      style={{ minHeight: "32px" }}
      values={assignedFacilityGroupCodeIds}
      label={`select one or more ${facilityCustomNameInSentence} group codes to use in workflow conditions for ${name}`}
    />
  )
}

FacilityGroupCodesSelect.propTypes = {
  facilityGroupCodes: types.arrayOf(types.object).isRequired,
}

export default FacilityGroupCodesSelect
